import { render } from "./Text-Input-Forms.vue?vue&type=template&id=0deff043"
import script from "./Text-Input-Forms.vue?vue&type=script&lang=js"
export * from "./Text-Input-Forms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__